import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Box,
  Grid,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { API_BASE_URL, API_BASE_URL1 } from "../../Services/baseApiUrl";
import JSZip from "jszip"; // Import JSZip
import { saveAs } from "file-saver"; // Import file-saver
import QRCode from "qrcode-svg";
import { jsPDF } from "jspdf";
// Using public folder paths for images
const logoLSD = "/assets/media/image/logo-LSD.png";
const logoLMC = "/assets/media/image/LMC-LOGO.jpg";

const AddQRCodeModal = ({ open, handleClose, editData }) => {
  const token = sessionStorage.getItem("token");
  const [numOfCodes, setNumOfCodes] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [qrGenerated, setQrGenerated] = useState(false);
  const [qrCodes, setQrCodes] = useState([]); // State to hold generated QR codes

  // Handle input change for number of QR codes
  // const handleNumOfCodesChange = (e) => {
  //   const value = e.target.value;
  //   setNumOfCodes(value);

  //   if (!value || value <= 0) {
  //     setError("Please enter a valid number of QR codes.");
  //   } else {
  //     setError("");
  //   }
  // };
  // const handleNumOfCodesChange = (e) => {
  //   const value = e.target.value;

  //   // Regular expression to allow only positive integers
  //   if (/^\d+$/.test(value)) {
  //     setNumOfCodes(value);
  //     setError("");
  //   } else {
  //     setError("Please enter a valid whole number of QR codes.");
  //   }
  // };

  // Function to call the API to generate QR codes
  const handleGenerateQRCodes = async () => {
    if (!numOfCodes || numOfCodes <= 0) {
      setError("Please enter a valid number of QR codes.");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.get(
        `${API_BASE_URL1}MasterDetails/generateVehicleUid?count=${numOfCodes}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response.data);
      if (response.data.statusCode === 200) {
        toast.success("QR Codes generated successfully!");
        setQrGenerated(true);
        // Set QR codes state to the 'data' array from response
        setQrCodes(response.data.data); // Save generated QR codes to state
        handleClose();
      } else {
        toast.error("Failed to generate QR codes.");
      }
    } catch (error) {
      console.error("Error generating QR codes:", error);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // Function to close the dialog and reset the fields
  const handleDialogClose = () => {
    handleClose();
    setNumOfCodes("");
    setError("");
    setQrGenerated(false);
    setQrCodes([]); // Reset QR codes state
  };

  // Function to download QR Codes
 const downloadQrCodesAsPDF = async () => {
  const zip = new JSZip();
  const qrSize = 1024;

  const promises = (Array.isArray(qrCodes) ? qrCodes : [])
    .filter((qrCodeValue) => qrCodeValue?.trim() !== "")
    .map((qrCodeValue, index) => {
      return new Promise((resolve, reject) => {
        const qr = new QRCode({
          content: qrCodeValue,
          padding: 4,
          width: qrSize,
          height: qrSize,
          color: "#000000",
          background: "#ffffff",
          ecl: "M",
        });

        const svg = qr.svg();
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = () => {
          canvas.width = qrSize;
          canvas.height = qrSize;
          ctx.drawImage(img, 0, 0, qrSize, qrSize);
          const imgData = canvas.toDataURL("image/jpeg", 1.0);
          
          // Custom paper size - tall format
          const pdf = new jsPDF("p", "mm", [90, 250]);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          // Load first logo (LSD logo)
          const logo1 = new Image();
          logo1.src = logoLSD;
          logo1.crossOrigin = "anonymous";

          // Load second logo (LMC logo)
          const logo2 = new Image();
          logo2.src = logoLMC;
          logo2.crossOrigin = "anonymous";

          logo1.onload = () => {
            logo2.onload = () => {
              // === Header with light beige background ===
              pdf.setFillColor(255, 230, 174); // Light beige color
              pdf.rect(0, 0, pageWidth, 18, 'F');
              
              // Add left logo with space
              pdf.addImage(logo1, 'PNG', 5, 3, 12, 12);
              
              // Add right logo with space
              pdf.addImage(logo2, 'PNG', pageWidth - 17, 3, 12, 12);

              // Main title in dark red
              pdf.setFont('helvetica', 'bold');
              pdf.setTextColor(153, 0, 0); // Dark red color
              pdf.setFontSize(7);
              pdf.text('LUCKNOW MUNICIPAL CORPORATION', pageWidth / 2, 9, { align: 'center' });

              // Subtitle in black
              pdf.setFontSize(6);
              pdf.setTextColor(0, 0, 0);
              pdf.text('LUCKNOW SWACHHATA ABHIYAN', pageWidth / 2, 14, { align: 'center' });

              // === QR Code in center - large size ===
              const qrWidthMM = 65; // Large QR code to match image
              const qrX = (pageWidth - qrWidthMM) / 2;
              const qrY = 18; // Positioned directly below header with no gap
              pdf.addImage(imgData, 'JPEG', qrX, qrY, qrWidthMM, qrWidthMM);

              // ==== Labels and Values ====
              const labels = ["UID:"];
              const values = [qrCodeValue];

              // Create table with thin borders - narrow and centered, directly below QR code
              const tableY = qrY + qrWidthMM + 0;
              const rowHeight = 6;
              const tableWidth = 70; // Narrow table width
              const tableX = (pageWidth - tableWidth) / 2; // Center the table
              const labelWidth = 35; // Width for label column
              const valueWidth = tableWidth - labelWidth; // Width for value column

              // Thin gray borders
              pdf.setDrawColor(200, 200, 200); // Light gray color for borders
              pdf.setLineWidth(0.2); // Thin line

              for (let i = 0; i < labels.length; i++) {
                const y = tableY + i * rowHeight;
                
                // Draw table border for each row (thin gray border)
                pdf.rect(tableX, y, tableWidth, rowHeight);
                
                // Draw vertical line to separate label and value columns
                pdf.line(tableX + labelWidth, y, tableX + labelWidth, y + rowHeight);
                
                // Add label in left column - bold, black, left-aligned
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(5.5);
                pdf.setTextColor(0, 0, 0); // Black text
                pdf.text(labels[i], tableX + 2, y + 4);
                
                // Add value in right column - bold, black, left-aligned
                pdf.setFont('helvetica', 'bold');
                pdf.setFontSize(5.5);
                pdf.setTextColor(0, 0, 0); // Black text
                pdf.text(values[i], tableX + labelWidth + 2, y + 4);
              }

              // Footer - smaller font
              pdf.setFontSize(2);
              pdf.setTextColor(100);
              pdf.setFont("helvetica", "normal");
              // pdf.text("Powered by VMax e-Solutions India Pvt Limited", pageWidth / 2, pageHeight - 1, { align: "center" });

              // Add to zip
              const pdfBlob = pdf.output("blob");
              zip.file(`${index + 1}_QRCode.pdf`, pdfBlob);
              resolve();
            };
            logo2.onerror = reject;
          };
          logo1.onerror = reject;
        };
        img.onerror = reject;
        img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
      });
    });

  try {
    await Promise.all(promises);
    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "all_generated_qrcodes.zip");
    toast.success(`ZIP file with ${qrCodes.length} QR codes downloaded successfully.`);
  } catch (error) {
    console.error("Error generating or downloading ZIP file:", error);
    toast.error("Error downloading QR codes. Please try again.");
  }
};





  return (
    <>
      {/* Dialog for generating QR codes */}
      <Dialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleDialogClose();
          }
        }}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">
              Generate QR Codes For Route Points
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleDialogClose}
              sx={{ color: "grey.500" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Number Of QR Codes"
                placeholder="Enter Number"
                type="number"
                size="small"
                margin="normal"
                value={numOfCodes}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,3}$/.test(value)) {
                    
                    setNumOfCodes(value);
                    if (value && value > 0) {
                      setError(""); // Reset error when the value is valid
                    }
                  }
                }}
                inputProps={{
                  min: 0, // Prevents negative numbers
                  step: 1, // Disallows decimal input
                  maxLength:3
                }}
                error={!!error}
                helperText={error}
              />

              {/* <TextField
                label="Number Of QR Codes"
                placeholder="Enter Number"
                // required
                type="number"
                size="small"
                margin="normal"
                value={numOfCodes}
                onChange={handleNumOfCodesChange}
                error={!!error}
                helperText={error}
                onInput={(e) =>
                  (e.target.value = Math.max(0, parseInt(e.target.value) || 0))
                }
              /> */}
            </Grid>
          </Grid>
        </DialogContent>
        <Box display="flex" justifyContent="flex-end" p={1}>
          <Button
            onClick={handleGenerateQRCodes}
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Generate QR Codes"}
          </Button>
        </Box>
      </Dialog>

      {/* Dialog for success message after QR codes are generated */}
      <Dialog
        open={qrGenerated}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <IconButton
          aria-label="close"
          onClick={handleDialogClose}
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            // color: 'white',
            // // backgroundColor: 'black',
            borderRadius: "50%",
            padding: "6px",
            // '&:hover': {
            //   backgroundColor: '#444',
            // },
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Box textAlign="center">
            <div className="flex justify-center">
              {/* <img
                src={TickIcon}
                alt="QR Codes Generated"
                style={{ width: "50px", marginTop: "25px" }}
              /> */}
            </div>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ marginTop: "8px", color: "#EC1117" }}
            >
              Generated QR Codes
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={downloadQrCodesAsPDF} // Call download function
              sx={{ marginTop: "30px", backgroundColor: "#868686" }}
            >
              Download QR Codes
            </Button>
            <div className="flex justify-center">
              {/* <img
                src={QRCodeSuccessImage}
                alt="QR Codes Generated"
                style={{ width: "200px", marginTop: "25px" }}
              /> */}
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddQRCodeModal;
